import { TSidebarVariant, TSidebarPosition } from '../types';

export const DEFAULT_IS_OPEN = true;
export const VARIANT_STANDARD = 'standard';
export const VARIANT_DRAWER = 'drawer';
export const VARIANT_NARROW = 'narrow';
export const DEFAULT_VARIANT: TSidebarVariant = VARIANT_STANDARD;
export const DEFAULT_POSITION: TSidebarPosition = 'left';
